import {Text} from '@smart/react-components';
import * as React from 'react';
import type {Maybe} from '../../graphql';
import {AppModelContext} from './app';
import {TextParser} from './text-parser';

interface IProps {
  className?: string;
  legalText?: Maybe<string>;
}

export function LegalLinks({className, legalText}: IProps): JSX.Element {
  const {legalNotes, privacyPolicy} =
    React.useContext(AppModelContext).cms.commonPages || {};

  const replacement = {
    privacy: {
      variant: `hyperlink-100`,
      href: privacyPolicy?._path || ``,
      target: `_blank`,
    },

    terms: {
      variant: `hyperlink-100`,
      href: legalNotes?._path || ``,
      target: `_blank`,
    },
  };

  return (
    <Text className={className} as="p">
      <TextParser text={legalText!} map={replacement} />
    </Text>
  );
}
